<template>
  <div v-if="numberOption.ShowNumber" class="number-wrap mr-3">
    <span>
      <svg v-if="numberOption.SkinCode" class="position-absolute" style="opacity: 0; z-index: -1;">
        <defs>
          <clipPath :id="`maskImage-numberPack-${elementId}`" clipPathUnits="objectBoundingBox"
            :style="{ transform: 'scale(0.01)' }" v-html="numberOption.SkinCode" />
        </defs>
      </svg>
    </span>
    <div :style="numberStyle" class="d-flex align-items-center justify-content-center">
      <span> {{ numberOption.Text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    numberOption: { type: [Object], default: null, required: true },
    numberStyle: { type: [Object], default: null, required: true },
    elementId: { type: [String], default: null, required: true },
  },
  methods: {

  }
}
</script>